export default "__VITE_ASSET__DhlXdci2__"